let data = [];

for (let i = 1; i <= 20; i++) {
  data.push({
    qrcode: "12345678",
    orderId: "order-00" + i,
    date: "2023-05-01",
    creator: "CcSimple",
  });
}

export default data;
